module.exports = __webpack_public_path__ + "img/bg_auth_desktop.e99c75a0.svg";